import Vue from "vue";
import moment from "moment";

Vue.mixin({
  data: () => ({
    MIXINS_REQUIRED_RULES: [v => !!v || "This field  is required"],
    MIXINS_EMAIL_RULES: [v => /.+@.+\..+/.test(v) || "Must be a valid e-mail"],
    MIXIN_PESO_SIGN: "&#x20B1;",
    MIXIN_MULTIPLICATION_SIGN: "&#215;",
    MIXIN_TRADEMARK_SIGN: "&trade;",
    MIXIN_COPYRIGHT_SIGN: "&copy;",
    MIXIN_MEDGATE_APP_ANDROID_LINK: "https://play.google.com/store/apps/details?id=com.medgate.Medgate",
    MIXIN_MEDGATE_APP_IOS_LINK: "https://apps.apple.com/us/app/medgate-philippines/id1552201874",
    MIXINS_ABOVE_21_RULES: [
      v => {
        return moment().diff(moment(v, "MM/DD/YYYY"), 'years') >= 21 || "Must be 21 years old or above"
      }
    ],
    MIXINS_ABOVE_18_RULES: [
      v => {
        return moment().diff(moment(v, "MM/DD/YYYY"), 'years') >= 18 || "Must be 18 years old or above"
      }
    ]
  }),
  computed: {
    MIXIN_SETUP_UI() {
      /**
       * ALL OBJECT KEY RETURN BY THIS FUNCTION MUST HAVE A COUNTERPART ON OTHER VIEWS
       */
      let breakpoint = this.$vuetify.breakpoint.name;

      if (["xs", "sm"].includes(breakpoint)) {
        return {
          header: "headline",
          title: "body-1",
          subtitle: "caption",
          description: "",
          caption: "",
          show: false, //for some components that dont show in smaller view
          defaultSidePadding: "px-3",
          defaultSideMargin: "mx-3",
          isSmallButton: true,
          components: {
            /** FOR SPECIFIC COMPONENTS */
            ABOUT_PAGE: {
              stackPhotoDescription: true,
              image: {
                height: {
                  small: "120px",
                  medium: "140px"
                },
                width: {
                  small: "120px",
                  medium: "130px"
                }
              }
            }
          }
        };
      }

      /**
       * "md", "lg", "xl"
       */
      return {
        header: "display-2",
        title: "headline",
        subtitle: "body-1",
        description: "",
        caption: "",
        show: true, //for some components that show in bigger view
        defaultSidePadding: "",
        defaultSideMargin: "",
        isSmallButton: false,
        components: {
          /** FOR SPECIFIC COMPONENTS */
          ABOUT_PAGE: {
            stackPhotoDescription: false,
            image: {
              height: {
                small: "180px",
                medium: "200px"
              },
              width: {
                small: "200px",
                medium: "300px"
              }
            }
          }
        }
      };
    }
  }
});
